@switch (customFieldType) {
  @case (ProposalCustomType.CHIPS) {
    <ax-custom-labels-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
      [isInListView]="isInListView"
      [isOwner]="isOwner"
    ></ax-custom-labels-view>
  }

  @case (ProposalCustomType.CHECK) {
    <ax-custom-check-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
      [isInListView]="isInListView"
      [isOwner]="isOwner"
    ></ax-custom-check-view>
  }
  @case (ProposalCustomType.RADIO) {
    <ax-custom-label-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
      [isOwner]="isOwner"
    ></ax-custom-label-view>
  }
  @case (ProposalCustomType.DROPDOWN) {
    <ax-custom-label-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
      [isOwner]="isOwner"
    ></ax-custom-label-view>
  }
  @case (ProposalCustomType.DATE) {
    <ax-custom-date-value-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
    ></ax-custom-date-value-view>
  }
  @case (ProposalCustomType.RATING) {
    <ax-custom-rating-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
    ></ax-custom-rating-view>
  }
  @case (ProposalCustomType.RICH_TEXT) {
    <ax-custom-rich-text-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
    ></ax-custom-rich-text-view>
  }
  @case (ProposalCustomType.TOGGLE) {
    <ax-custom-toggle-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
    ></ax-custom-toggle-view>
  }
  @case (ProposalCustomType.HASHED_VALUE) {
    <ax-custom-hashed-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
    ></ax-custom-hashed-view>
  }
  @default {
    <ax-custom-value-view
      [property]="property"
      [requestedPropertyType]="requestedPropertyType"
      [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
    ></ax-custom-value-view>
  }
}
